import React, {useState} from 'react';
import NudgeBar from './NudgeBar';
import {useMessageOfTheDayQuery} from '../generated/graphql';

const MessageOfTheDay: React.FC = () => {
  const {data} = useMessageOfTheDayQuery();

  const lastMessageDismissed = localStorage.getItem('lastMessageDismissedText');

  const message = data?.serverInfo?.messageOfTheDay;

  if (!message || lastMessageDismissed === message) {
    return null;
  }
  return <MessageOfTheDayLoaded message={message} />;
};

export default MessageOfTheDay;

type MessageOfTheDayLoadedProps = {
  message: string;
};

const MessageOfTheDayLoaded: React.FC<MessageOfTheDayLoadedProps> = ({
  message,
}) => {
  const [open, setOpen] = useState(true);

  const handleClose = () => {
    localStorage.setItem('lastMessageDismissedText', message);
    setOpen(false);
  };
  if (!open) {
    return null;
  }

  return (
    <NudgeBar
      content={message}
      showDismissOption={true}
      onClose={handleClose}
    />
  );
};
